'use strict';

function isSafari() {
  return !!window.safari;
}

module.exports = isSafari;


/*****************
 ** WEBPACK FOOTER
 ** ../modules/utils/isSafari.js
 ** module id = 42
 ** module chunks = 0
 **/